import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import { useTestSeriesData } from './useTestSeriesData';

const StatsCardsWrapper = styled.div`
  background-color: var(--color-bg-yellow);
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: start;

  ${mediaQuery.uptoMobile} {
    padding: 40px 20px;
  }
`;

const Title = styled.p`
  color: var(--color-brown-title);
  font-weight: 700;
  font-size: 48px;
  line-height: 120%;
  letter-spacing: -2%;
  text-align: center;

  ${mediaQuery.uptoMobile} {
    font-weight: 700;
    font-size: 38px;
    line-height: 120%;
    letter-spacing: -2%;
    text-align: left;
  }
`;

const StatsContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 60%;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 60px;

  ${mediaQuery.uptoMobile} {
    gap: 16px;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
  }
`;

const StatCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  ${mediaQuery.uptoMobile} {
    gap: 8px;
  }
`;

const StatCardValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${mediaQuery.uptoMobile} {
    gap: 4px;
  }
`;

const StatCardIcon = styled.img`
  height: 96px;

  ${mediaQuery.uptoMobile} {
    height: 70px;
  }
`;

const StatValue = styled.p`
  color: var(--color-brown-title);
  font-weight: 700;
  font-size: 40px;
  line-height: 40px;
  letter-spacing: -1%;

  ${mediaQuery.uptoMobile} {
    font-size: 30px;
    line-height: 38px;
  }
`;

const StatCardTitle = styled.p`
  color: var(--color-brown-title);
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5%;

  ${mediaQuery.uptoMobile} {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
`;

const StatCardDescription = styled.p`
  color: var(--color-brown-title);
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;

  ${mediaQuery.uptoMobile} {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
`;

const StatsCards = () => {
  const { data } = useTestSeriesData();
  if (!data?.statsSectionTitle || !data?.statsCard) return null;
  const { statsSectionTitle, statsCard } = data;

  if (!Array.isArray(statsCard) || statsCard.length === 0) return null;

  return (
    <StatsCardsWrapper>
      <Title>{statsSectionTitle || ''}</Title>
      <StatsContainer>
        {statsCard.map((stat) => {
          return (
            <StatCard key={stat?.title}>
              <StatCardIcon
                src={stat?.icon?.url ?? getImage('testseries/trophy.svg')}
              />
              <StatCardValueContainer>
                <StatValue>{stat?.stats || ''}</StatValue>
                <StatCardDescription>
                  {stat?.supportingText || ''}
                </StatCardDescription>
                <StatCardTitle>{stat?.title || ''}</StatCardTitle>
              </StatCardValueContainer>
            </StatCard>
          );
        })}
      </StatsContainer>
    </StatsCardsWrapper>
  );
};

export default StatsCards;
